export const config = {
    REACT_APP_YOUTUBE_API_BASE_URL: "https://www.googleapis.com/youtube/v3",
    REACT_APP_YOUTUBE_API_KEY: "AIzaSyDlpyTO38vfkeIvwvXfM8fLfYEmzXqWVv4",
};
